import { List } from 'immutable';
import { valuationPolicyConstants } from '../constants';
import { sortByAsc } from '../views/helpers';

export function valuation_policies(state = {}, action) {
  switch (action.type) {
    case valuationPolicyConstants.VALUATION_POLICY_LIST_LOADING:
      return {
        ...state,
        items: null,
        listLoading: true
      };
    case valuationPolicyConstants.VALUATION_POLICY_LIST_SUCCESS:
      return {
        ...state,
        items: List(action.response),
        listLoading: false
      };
    case valuationPolicyConstants.VALUATION_POLICY_LIST_FAILURE:
      return {
        ...state,
        listLoading: false,
        items: null,
        listError: action.error
      };
    case valuationPolicyConstants.VALUATION_POLICY_CREATE_LOADING:
      return {
        ...state,
        createLoading: true
      };

    case valuationPolicyConstants.VALUATION_POLICY_CREATE_SUCCESS: {
      const items = state.items ? state.items : List();
      return {
        ...state,
        items: sortByAsc(items.push(action.response), 'effectiveFrom'),
        createLoading: false,
        createError: null
      };
    }

    case valuationPolicyConstants.VALUATION_POLICY_CREATE_FAILURE:
      return {
        ...state,
        createLoading: false,
        createError: action.error
      };

    case valuationPolicyConstants.VALUATION_POLICY_EDIT_LOADING:
      return {
        ...state,
        editLoading: true
      };
    case valuationPolicyConstants.VALUATION_POLICY_EDIT_SUCCESS: {
      if (!state.items) {
        return state;
      }

      const valuationPolicyIndex = state.items.findIndex(val => val.id == action.response.id);

      if (valuationPolicyIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.set(valuationPolicyIndex, action.response),
        editLoading: false,
        editError: null
      };
    }
    case valuationPolicyConstants.VALUATION_POLICY_EDIT_FAILURE:
      return {
        ...state,
        editLoading: false,
        editError: action.error
      };

    case valuationPolicyConstants.VALUATION_POLICY_DELETE_LOADING:
      return {
        ...state,
        deleteLoading: true
      };
    case valuationPolicyConstants.VALUATION_POLICY_DELETE_SUCCESS: {
      const { valuationPolicyId } = action;

      if (!state.items) {
        return state;
      }

      const valuationPolicyIndex = state.items.findIndex(val => val.id == valuationPolicyId);

      if (valuationPolicyIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.delete(valuationPolicyIndex),
        deleteLoading: false,
        deleteError: null
      };
    }
    case valuationPolicyConstants.VALUATION_POLICY_DELETE_FAILURE:
      return {
        ...state,
        deleteLoading: false,
        deleteError: action.error
      };
    case valuationPolicyConstants.VALUATION_POLICY_ERROR_RELOAD:
      return {
        ...state,
        createError: null,
        editError: null
      };

    default:
      return state;
  }
}
